import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useToast } from '../hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

const AdminUsersTable = () => {
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(null);
  const { toast } = useToast();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${BACKEND_URL}/api/admin/users/overview`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSummary(response.data);
      } catch (error) {
        console.error('Error loading admin overview:', error);
        toast({
          title: 'Admin Error',
          description:
            error.response?.data?.detail || 'Failed to load admin overview.',
          variant: 'destructive',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [toast]);

  if (loading) {
    return <div className="text-xs text-gray-400">Loading users...</div>;
  }

  if (!summary) {
    return <div className="text-xs text-red-400">No data available.</div>;
  }

  return (
    <div className="mt-4 text-xs text-gray-200">
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <span>Total users: <span className="font-semibold">{summary.total_users}</span></span>
        <span>Total games: <span className="font-semibold">{summary.total_games}</span></span>
        <span>Total spent: <span className="font-semibold">${summary.total_spent.toFixed(2)}</span></span>
      </div>
      <div className="overflow-x-auto border border-white/10 rounded-lg">
        <table className="min-w-full text-left text-xs">
          <thead className="bg-white/5 text-gray-300">
            <tr>
              <th className="px-3 py-2">Email</th>
              <th className="px-3 py-2">Username</th>
              <th className="px-3 py-2">Games</th>
              <th className="px-3 py-2">Credits</th>
              <th className="px-3 py-2">Plan</th>
              <th className="px-3 py-2">Total Spent</th>
            </tr>
          </thead>
          <tbody>
            {summary.users.map((u) => (
              <tr key={u.user_id} className="border-t border-white/5 hover:bg-white/5">
                <td className="px-3 py-2 text-gray-100">{u.email}</td>
                <td className="px-3 py-2 text-gray-300">{u.username}</td>
                <td className="px-3 py-2">{u.total_games}</td>
                <td className="px-3 py-2">{u.credits}</td>
                <td className="px-3 py-2">{u.subscription === 'pro' && u.subscription_status === 'active' ? 'Pro' : 'Free'}</td>
                <td className="px-3 py-2">${u.total_spent.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminUsersTable;
